import React from 'react'

function SingleNewsPage() {
  return (
    <main>
        <div className="main_section_1_img_wrapper">
            <img src={require("./static/img/main.jpg")} alt="" />
            <h2 className="blur_div">
                &nbsp;
                “MARYAWTOULAG” <br />
                ÖNÜMÇILIK BIRLEŞIGI
                <img src={require("./static/img/arrow_down.png")} alt="" />
            </h2>
        </div>


        <div className="news_title_section">
            <h2>TÄZELIKLER</h2>
            <img src={require("./static/img/element2.png")} className="" alt="" />
        </div>

        <div className="single_news_wrapper">
            <img className="single_news_decoration" src={require("./static/img/element3.jpg")} alt="" />
            
            <div className="single_news_inner_wrapper">
                

                <div className="news_image_wrapper">
                    <img src={require("./static/img/news_example_1.jpg")} alt="" />
                </div>
                <div className="news_date">
                    <span>12.11.2022</span>
                </div>

                <div className="news_title">
                    <span>Türkmen samboçylary Bişkek şäherinde geçirilýän dünýä çempionatynda altyn we bürünç medallarynyň ikisini gazandylar</span>
                </div>

                <div className="news_content">
                    <p>Türkmen samboçylary Gyrgyz Respublikasynyň Bişkek şäherinde dowam edýän 47-nji Sambo boýunça dünýä çempionatynda altyn we bürünç medallarynyň ikisine mynasyp boldular.</p>
                    <p>Halkar ýaryş, sport we söweş sambosynda&nbsp;erkekleriň we zenanlaryň arasynda 21 agram derejesinde iň güýçli diýen ugurda göreşýän 50-ä golaý döwletden 400-den gowrak türgen ýygnady.</p>
                    <p>Bäsleşigiň ilkinji gününde Türkmenistanyň milli ýygyndy toparyndan Içeri işler ministrliginiň Mälikguly Berdimuhamedow adyndaky 1001-nji harby bölüminiň esgeri Muhammet Kössekow iň ýokary baýraga mynasyp bolmaga başardy. Bu üstünlige Aşgabatdan gelen 24 ýaşly sport ussady, 64 kilograma çenli agram derejesinde ýetdi.</p>
                    <p>Ilkinji tutluşykda Muhammet 2022-nji ýyldaky dünýä çempionatynyň bürünç medalyna eýe bolan Ermenistanly Maksim Manukýanden, soňra bolsa Bolgariýaly Dimitar Stoýanowden üstün çykmagy başardy . Ýarym finalda ildeşimiz Gazagystan Respublikasyndan 2021-nji ýyldaky Dünýä ýaşlar çempionatynyň bürünç medalynyň eýesi Esentaý Imahanowdan has güýçli çykdy. Finalda bolsa, işjeňligi bilen Azerbaýjan Respublikasyndan Elwin Bagirowy 1:0 hasabynda ýeňmäne başardy.</p>
                    <p>Muhammet Kössekow ilkinji gezek dünýä çempiony bolýar. Geçen ýyl Daşkent şäherinde geçirilen Aziýa çempionatynda finalda Gazagystan Respublikasyndan Rahat Žanananiýeti ýeňip, altyn medala mynasyp boldy. Ýeňiji tutluşykdan soňra, M.Kössekow Halkara Sambo federasiýasynyň resmi web-sahypasyna beren interwýusynda: «Ýeňiş üçin öňümizdäki dünýä çempionadyna gidern» diýdi. Muhammet häzirki dünýä çempionatynda münberiň iň ýokary basgançagyna çykyp, sözünde durdy.</p>
                    <p>Zehinli samboçy birnäçe ýyl bäri bu üstünlige taýynlyk gördi. Ol ýaş Olimpiýaçylaryň mekdebinde tälimçi Döwlet Tejenow bilen sport ussatlygynyň esaslaryna düşündi. Soňra, Türkmen döwlet bedenterbiýe we sport institutynda okaýan ýyllarynda Türkmenistanyň at gazanan tälimçisi Dörtguly Tejenowdan tälim aldy. Häzirki wagtda Muhammet Kössekow Türkmenistanyň Içeri işler ministrliginiň Mälikguly Berdimuhamedow adyndaky 1001-nji harby bölüminde harby gullugynda we Türkmenistanyň at gazanan tälimçisi Nurýagdy Mamedow bilen Içeri işler ministrliginiň «Galkan» sport klubynda sambo ussatlygyny kämilleşdirýär.</p>
                    <p>Şeýle-de şu gün, dünýä çempionatynyň ikinji gününde Türkmenistanyň milli ýygyndysy ýene bürünç medallarynyň ikisini gazandylar. Bu medallara Türkmenistanyň söweş sungaty Milli federasiýasynyň türgeni Kakageldi Ýegenbaýew (71 kilograma çenli) we ýurdumyzyň Bedenterbiýe we sport baradaky döwlet komitetiniň sport mekdebiniň tälimçisi Batyr Hojamuhammedow (98 kg-dan gowrak) mynasyp bolmaga başardylar.</p>
                </div>
            </div>

            
        </div>
    </main>
  )
}

export default SingleNewsPage